import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {TrendInformation} from "./model";
import {DetectMethodChanges} from "../utils";

@Component({
    selector: 'ets-trend-icon-component',
    template: `
        <div [ngSwitch]="trend" #icon>
            <i *ngSwitchCase="'Up'" class="trend-icon up dx-icon-arrowup"></i>
            <i *ngSwitchCase="'Down'" class="trend-icon down dx-icon-arrowdown"></i>
            <i *ngSwitchCase="'Flat'" class="trend-icon flat dx-icon-isnotblank"></i>
            <i *ngSwitchCase="'None'" class="trend-icon none dx-icon-minus"></i>
            <i *ngSwitchDefault class="trend-icon none dx-icon-minus"></i>
        </div>
        <ng-container *ngIf="this.settingsAccess">
          <dx-popover
            [target]="icon"
            showEvent="dxhoverstart"
            hideEvent="dxhoverend"
          >
            <div *dxTemplate="let data of 'content'">
              <div class="trend-info">
                <div class="info close">
                  <div class="label">Close</div>
                  <div class="value">{{ this.info?.closePrice | number:'1.2-2' }}</div>
                </div>
                <div class="info ema">
                  <div class="label">EMA</div>
                  <div class="value">{{ this.info?.emaValue | number:'1.2-2' }}</div>
                </div>
                <div class="info slope">
                  <div class="label">Slope</div>
                  <div class="value">{{ this.info?.slope | number:'1.2-2' }}</div>
                </div>
                <div class="info range">
                  <div class="label">Range</div>
                  <div class="value">{{ this.info?.range | number:'1.2-2' }}</div>
                </div>
              </div>
            </div>
          </dx-popover>
        </ng-container>
    `,
    styles: [`
        .trend-icon {
            font-size: 16px;
        }
        .trend-icon.up { color: #28a745; }
        .trend-icon.down { color: #dc3545; }
        .trend-icon.flat { color: #ffc107; }
        .trend-icon.none { color: #6c757d; }
        
        .trend-info {
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            padding: 10px;
        }
        
        .info {
            display: flex;
            column-gap: 10px;
        }
        
        .label {
            flex: 2;
            font-weight: 800;
        }
        
        .value {
            flex: 1;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrendIconComponent implements OnInit {

    constructor(private _changeDetector: ChangeDetectorRef) {
    }

    @Input() trend: string = '';

    @Input() info: TrendInformation;

    @Input() settingsAccess: boolean;

    @DetectMethodChanges()
    ngOnInit(): void {
    }
}